import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import TourV2RouteMapModal from './TourV2RouteMapModal'
import useToggle from 'hooks/useToggle'
import Clickable from 'components/Common/Clickable'
import TourV2Itinerary from './TourV2Itinerary'
import LineFocusIcon from 'components/Luxkit/Icons/line/LineFocusIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'

const Root = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: ${rem(30)};

  ${mediaQueryUp.sm} {
    flex-direction: row;
  }

  > .itinerary-area {
    flex-grow: 1;
  }

  > .map-area {
    flex-shrink: 0;
  }
`

const RouteMapModalActivator = styled(Clickable)`
  display: flex;
  border-radius: ${props => props.theme.borderRadius.large};
  overflow: hidden;
  position: relative;

  ${mediaQueryUp.sm} {
    max-width: ${rem(457)};
    max-height: ${rem(685)};
    position: sticky;
    top: ${rem(130)}; /* sticky header height (118) + margin (12) */
  }
`

const ExpandBadge = styled.div`
  display: flex;
  position: absolute;
  border-radius: ${props => props.theme.borderRadius.medium};
  right: 0;
  bottom: 0;
  margin: ${rem(8)};
  gap: ${rem(8)};
  padding: ${rem(8)};
  background-color: rgba(0, 0, 0, .8);
`
interface Props {
  offerType: Tours.V2OfferType
  itinerary: Tours.V2OfferItineraryItem[]
  variation?: Tours.V2OfferVariation
}

function TourV2ItineraryAndMap(props: Props) {
  const { itinerary, variation, offerType } = props
  const routeMapImage = variation?.routeMapImage

  const [mapModalOpen, , openMapModal, closeMapModal] = useToggle(false)
  return <>
    <Root>
      <div className="itinerary-area">
        <TourV2Itinerary itinerary={itinerary} title="What you'll see" offerType={offerType} />
      </div>

      {!!routeMapImage && <div className="map-area">
        <RouteMapModalActivator onClick={openMapModal}>
          <ResponsiveImage
            id={routeMapImage.id}
            alt={routeMapImage.title}
            smWidth="370px"
            mdWidth="457px"
            xs="1:1"
            sm={undefined}
          />

          <ExpandBadge>
            <LineFocusIcon size="S" colour="neutral-eight" />
            <BodyText variant="medium" colour="neutral-eight">Expand map</BodyText>
          </ExpandBadge>
        </RouteMapModalActivator>
      </div>}

    </Root>

    {!!routeMapImage && <TourV2RouteMapModal
      open={mapModalOpen}
      onClose={closeMapModal}
      variation={variation}
    />}
  </>
}

export default TourV2ItineraryAndMap
